import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DoHttpService } from 'src/app/core/services/do-http.service';
import { ApiUrls } from 'src/app/shared/constants/ApiUrls';
import { CadSoftwares, CadSoftwaresForBuying, sketchProducts } from 'src/app/shared/constants/common/cad-software-list';
import { CadSoftware } from 'src/app/shared/enum/common/CadSoftware';
import { ProductTypeEnum } from 'src/app/shared/enum/ProductTypeEnum';
import { BillingCycle, SubscriptionPlan, SubscriptionState } from 'src/app/shared/interfaces/ISubscription';

@Component({
  selector: 'app-purchase-new-app',
  templateUrl: './purchase-new-app.component.html',
  styleUrl: './purchase-new-app.component.scss'
})
export class PurchaseNewAppComponent {

  @Input() isSingleAppPurchase: boolean = false;
  @Input() hideCadSoftwareSelection: boolean = false;
  @Input() subscriptionState: SubscriptionState;
  @Output() subscriptionStateChange = new EventEmitter();
  @Input() selectedBillingCycle: 'Monthly' | 'yearly';
  @Output() selectedBillingCycleChange = new EventEmitter<'Monthly' | 'Yearly'>();
  @Output() selectedAppChanged = new EventEmitter<ProductTypeEnum>();
  @Output() goForward = new EventEmitter();

  selectedProduct!: ProductTypeEnum;
  @Input() selectedCurrency = 'DKK';

  selectedSketchSoftware: CadSoftware | null = null;
  selectedSketchType: 'CTS' | 'Normal' | null = null;
  selectedSketch: ProductTypeEnum | null = null;

  productType = ProductTypeEnum;
  availableApps = [
    {
      name: 'Sketch',
      type: ProductTypeEnum.Sketch
    },
    {
      name: 'Testspace',
      type: ProductTypeEnum.Testspace
    },
    // {
    //   name: 'Zen',
    //   type: ProductTypeEnum.LegacyZen
    // },
    // {
    //   name: 'Workspace',
    //   type: ProductTypeEnum.DrawoutApp
    // },
  ]

  cadSoftwares = CadSoftwaresForBuying;
  allPlans: SubscriptionPlan[] = [];
  isPlansLoading = false;

  constructor(
    private route: ActivatedRoute,
    private request: DoHttpService) {
    this.isAppSelected = this.isAppSelected.bind(this)
  }

  ngOnInit(): void {
    this.loadPlans();
    if (this.isSketchSelected(this.subscriptionState.selectedApp)) {
      this.selectedProduct = ProductTypeEnum.Sketch;
      // Sketch is sold yearly only — force the cycle to Yearly when a sketch is
      // pre-selected on load (selectProduct/switchCadSoftware already do this for
      // interactive selection), so the hidden switcher can't leave it on Monthly.
      this.selectedBillingCycleChange.emit('Yearly');
      this.selectedSketch = this.subscriptionState.selectedApp;
      if (this.selectedSketch === ProductTypeEnum.EplanSketch) {
        this.selectedSketchSoftware = CadSoftware.EPLAN;
      } else if (this.selectedSketch === ProductTypeEnum.PCSSketch) {
        this.selectedSketchSoftware = CadSoftware['PC Schematic'];
      } else if (this.selectedSketch === ProductTypeEnum.SEESketch) {
        this.selectedSketchSoftware = CadSoftware['SEE Electrical'];
      }
    } else {
      this.selectedProduct = this.subscriptionState.selectedApp;
      this.selectedSketch = null;
      this.selectedSketchSoftware = null;
    }
    // this.route.params.subscribe(res => {
    //   const type = Number(res['id']);
    //   if (!type || type === 0) {
    //     this.selectedProduct = ProductTypeEnum.Sketch;
    //     this.selectedSketchSoftware = CadSoftware.EPLAN;
    //     this.selectedSketch = ProductTypeEnum.EplanSketch;
    //   } else {
    //     this.selectedProduct = type;
    //     if (this.selectedProduct === ProductTypeEnum.Sketch) {
    //       this.selectedSketchSoftware = CadSoftware.EPLAN;
    //       this.selectedSketch = ProductTypeEnum.EplanSketch;
    //     } else if (this.isSketchSelected(this.selectedProduct)) {
    //       //Need to implement CTS SKETCH LATER
    //       switch (this.selectedProduct) {
    //         case ProductTypeEnum.EplanSketch: case ProductTypeEnum.EplanCTSSketch: {
    //           this.selectedSketch = ProductTypeEnum.EplanSketch;
    //           this.selectedSketchSoftware = CadSoftware.EPLAN;
    //           this.selectedProduct = ProductTypeEnum.Sketch;
    //           break;
    //         }
    //         case ProductTypeEnum.SEESketch: case ProductTypeEnum.SEECTSSketch: {
    //           this.selectedSketch = ProductTypeEnum.SEESketch;
    //           this.selectedSketchSoftware = CadSoftware['SEE Electrical'];
    //           this.selectedProduct = ProductTypeEnum.Sketch;
    //           break;
    //         }
    //         case ProductTypeEnum.PCSSketch: case ProductTypeEnum.PCSCTSSketch: {
    //           this.selectedSketch = ProductTypeEnum.PCSSketch;
    //           this.selectedSketchSoftware = CadSoftware['PC Schematic'];
    //           this.selectedProduct = ProductTypeEnum.Sketch;
    //           break;
    //         }
    //       }
    //     }
    //   }
    // })
  }

  loadPlans() {
    this.isPlansLoading = true;
    this.request.get<SubscriptionPlan[]>(ApiUrls.getAllSubscriptionPlans).subscribe(res => {
      this.allPlans = res;
      this.isPlansLoading = false;
    })
  }

  isSketchSelected(type: ProductTypeEnum) {
    return type === ProductTypeEnum.Sketch || sketchProducts.map(item => item.id).includes(type);
  }

  selectProduct(productType: ProductTypeEnum) {
    this.selectedProduct = productType
    this.selectedBillingCycleChange.emit('Yearly')
    // this.selectedBillingCycle = BillingCycle.Annually;
    if (this.isSketchSelected(this.selectedProduct)) {
      this.updateSubscriptionState(ProductTypeEnum.EplanSketch)
      this.selectedSketchSoftware = CadSoftware.EPLAN;
      this.updateSelectedSketch();
    } else {
      this.updateSubscriptionState(productType)
      this.selectedSketchSoftware = null;
      this.selectedSketch = null;
    }
  }

  switchCadSoftware(software: any) {
    this.selectedSketchSoftware = software;
    this.selectedBillingCycleChange.emit('Yearly')
    // this.selectedBillingCycle = BillingCycle.Annually;
    this.updateSelectedSketch();
  }

  isAppSelected(selectedApp: ProductTypeEnum, type: ProductTypeEnum) {
    if (type === ProductTypeEnum.Sketch && this.isSketchSelected(selectedApp)) {
      return true;
    } else {
      return selectedApp === type;
    }
  }

  updateSelectedSketch() {
    switch (this.selectedSketchSoftware) {
      case CadSoftware.EPLAN: {
        this.selectedSketch = ProductTypeEnum.EplanSketch;
        this.updateSubscriptionState(this.selectedSketch)
        break;
      }
      case CadSoftware['SEE Electrical']: {
        this.selectedSketch = ProductTypeEnum.SEESketch;
        this.updateSubscriptionState(this.selectedSketch)
        break;
      }
      case CadSoftware['PC Schematic']: {
        this.selectedSketch = ProductTypeEnum.PCSSketch;
        this.updateSubscriptionState(this.selectedSketch)
        break;
      }
    }
  }

  onBillingCycleChanged(e) {
    this.selectedBillingCycleChange.emit(e)
  }

  updateSubscriptionState(app) {
    const data: SubscriptionState = {
      selectedApp: app,
      viewMode: 0,
      selectedPlans: {
        "1": null,
        "2": null,
        "3": null,
        "4": null,
        "5": null,
        "6": null,
        "7": null,
        "8": null,
        "9": null,
        "10": null,
      },
    }
    this.subscriptionStateChange.emit(data);
  }

  subscriptionStateChanged(e) {
    this.subscriptionStateChange.emit(e);
  }
}
